function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1c88c7",
  d: "M1152 512V40q22 14 36 28l408 408q14 14 28 36h-472zm-128 32q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28H224q-40 0-68-28t-28-68V96q0-40 28-68t68-28h800v544z"
});

function SvgMisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1792 1792",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTc5MiAxNzkyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGZpbGw9IiMxYzg4YzciIGQ9Ik0xMTUyIDUxMnYtNDcycTIyIDE0IDM2IDI4bDQwOCA0MDhxMTQgMTQgMjggMzZoLTQ3MnptLTEyOCAzMnEwIDQwIDI4IDY4dDY4IDI4aDU0NHYxMDU2cTAgNDAtMjggNjh0LTY4IDI4aC0xMzQ0cS00MCAwLTY4LTI4dC0yOC02OHYtMTYwMHEwLTQwIDI4LTY4dDY4LTI4aDgwMHY1NDR6Ii8+PC9zdmc+Cg==";
export { SvgMisc as ReactComponent };